// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
// Function to update inventory and date for a variant
function updateVariantInfo(variant) {
  if (!variant || !variant.id) {
    return;
  }
  
  const variantId = String(variant.id);
  
  // Update inventory status
  const inventoryStatusContainer = document.querySelector('[data-product-inventory-status]');
  const inventoryStatusText = document.querySelector('[data-inventory-status-text]');
  
  if (inventoryStatusContainer && inventoryStatusText) {
    // Try to find the variant inventory element
    const variantInventoryEl = document.querySelector('[data-variant-inventory-status="' + variantId + '"]');
    
    if (variantInventoryEl) {
      const inventoryMessage = variantInventoryEl.getAttribute('data-inventory-status-message');
      
      if (inventoryMessage && inventoryMessage.trim() !== '') {
        inventoryStatusText.textContent = inventoryMessage;
        inventoryStatusContainer.style.display = '';
        
        // Set status color based on message
        inventoryStatusContainer.removeAttribute('data-status');
        if (inventoryMessage.toLowerCase().includes('out of stock')) {
          inventoryStatusContainer.setAttribute('data-status', 'out-of-stock');
        } else if (inventoryMessage.toLowerCase().includes('only') && inventoryMessage.toLowerCase().includes('left')) {
          inventoryStatusContainer.setAttribute('data-status', 'low');
        } else if (inventoryMessage.toLowerCase() === 'available') {
          inventoryStatusContainer.setAttribute('data-status', 'available');
        }
      } else {
        // If message is empty, still show container but keep current text
        inventoryStatusContainer.style.display = '';
      }
    } else {
      // If variant element not found, try to find all and log for debugging
      const allInventoryElements = document.querySelectorAll('[data-variant-inventory-status]');
      console.log('Looking for variant ID:', variantId);
      console.log('Found', allInventoryElements.length, 'inventory elements');
      // Keep container visible even if variant not found
      inventoryStatusContainer.style.display = '';
    }
  }
  
  // Update release date
  const releaseDateContainer = document.querySelector('[data-product-release-date]');
  const releaseDateText = document.querySelector('[data-release-date-text]');
  
  if (releaseDateContainer && releaseDateText) {
    const variantReleaseDateEl = document.querySelector('[data-variant-release-date="' + variantId + '"]');
    
    if (variantReleaseDateEl) {
      const hasStock = variantReleaseDateEl.getAttribute('data-has-stock') === 'true';
      const releaseDateRaw = variantReleaseDateEl.getAttribute('data-release-date-raw');
      const releaseDateValue = variantReleaseDateEl.getAttribute('data-release-date-value');
      
      if (hasStock) {
        releaseDateContainer.classList.add('hide');
      } else if (releaseDateRaw && releaseDateRaw.trim() !== '') {
        const releaseDate = new Date(releaseDateRaw + 'T00:00:00');
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        
        if (releaseDate > now && releaseDateValue && releaseDateValue.trim() !== '') {
          releaseDateText.textContent = releaseDateValue;
          releaseDateContainer.classList.remove('hide');
        } else {
          releaseDateContainer.classList.add('hide');
        }
      } else {
        releaseDateContainer.classList.add('hide');
      }
    } else {
      releaseDateContainer.classList.add('hide');
    }
  }
}

// Remove hide class from product__price elements
function removeHideClassFromPrice() {
  const priceElements = document.querySelectorAll('.product__price');
  priceElements.forEach(priceEl => {
    if (priceEl.classList.contains('hide')) {
      priceEl.classList.remove('hide');
    }
  });
}

// Remove hide class immediately and on variant changes
removeHideClassFromPrice();

// Use MutationObserver to watch for hide class being added
const priceObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const target = mutation.target;
      if (target.classList && target.classList.contains('product__price') && target.classList.contains('hide')) {
        target.classList.remove('hide');
      }
    }
  });
});

// Observe all product__price elements
document.addEventListener('DOMContentLoaded', function() {
  const priceElements = document.querySelectorAll('.product__price');
  priceElements.forEach(priceEl => {
    priceObserver.observe(priceEl, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
  
  // Also remove hide class initially
  removeHideClassFromPrice();
});

// Also remove on variant change
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log("Event detail:", evt.detail);
  console.log("Variant from event:", evt.detail?.variant);
  
  // Remove hide class from price
  removeHideClassFromPrice();
  
  // Try to get variant from event
  let variant = evt.detail?.variant;
  
  // If variant is null, show "Out of stock"
  if (!variant || variant === null) {
    console.log("Variant is null, showing Out of stock");
    const inventoryStatusContainer = document.querySelector('[data-product-inventory-status]');
    const inventoryStatusText = document.querySelector('[data-inventory-status-text]');
    
    if (inventoryStatusContainer && inventoryStatusText) {
      inventoryStatusText.textContent = 'Out of stock';
      inventoryStatusContainer.style.display = '';
      inventoryStatusContainer.setAttribute('data-status', 'out-of-stock');
    }
    
    // Update price to show "Select an available size to see price"
    const priceElements = document.querySelectorAll('[data-price]');
    priceElements.forEach(priceEl => {
      // Only update if it's not already showing the message
      if (priceEl.textContent.trim() !== 'Select an available size to see price') {
        priceEl.textContent = 'Select an available size to see price';
        // Hide compare price if it exists
        const comparePrice = priceEl.parentElement.querySelector('[data-compare-price]');
        if (comparePrice) {
          comparePrice.style.display = 'none';
        }
      }
    });
    
    // Update button to be outlined and disabled
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    addToCartButtons.forEach(btn => {
      btn.classList.add('btn--secondary');
      btn.classList.remove('btn--primary');
      btn.setAttribute('disabled', 'disabled');
      const text = btn.querySelector('[data-add-to-cart-text]');
      if (text) {
        text.textContent = 'Out of stock';
      }
    });
    
    // Also hide the release date
    const releaseDateContainer = document.querySelector('[data-product-release-date]');
    if (releaseDateContainer) {
      releaseDateContainer.classList.add('hide');
    }
    
    return;
  }
  
  // If variant doesn't have an id, try to get it from the form
  if (!variant.id) {
    console.log("Variant missing id, trying form inputs...");
    
    // Try hidden input first (most reliable after form update)
    const idInput = document.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      variant = { id: parseInt(idInput.value, 10) };
      console.log("Got variant ID from hidden input:", variant.id);
    } else {
      // Try select dropdown
      const selectInput = document.querySelector('select[name="id"]');
      if (selectInput && selectInput.value) {
        variant = { id: parseInt(selectInput.value, 10) };
        console.log("Got variant ID from select:", variant.id);
      } else {
        // Try data attribute as last resort
        const formElement = document.querySelector('[data-product-form]');
        if (formElement) {
          const currentProductId = formElement.getAttribute('data-current-product-id');
          if (currentProductId) {
            variant = { id: parseInt(currentProductId, 10) };
            console.log("Got variant ID from data attribute:", variant.id);
          }
        }
      }
    }
  } else {
    console.log("Using variant from event, ID:", variant.id);
  }
  
  if (variant && variant.id) {
    // Check if variant data is actually valid (has price or other valid data)
    const variantInventoryEl = document.querySelector('[data-variant-inventory-status="' + String(variant.id) + '"]');
    
    // If variant element doesn't exist, it means the variant is null/invalid
    if (!variantInventoryEl) {
      console.log("Variant ID exists but variant data is null/invalid");
      
      // Update price to show "Select an available size to see price"
      const priceElements = document.querySelectorAll('[data-price]');
      priceElements.forEach(priceEl => {
        if (priceEl.textContent.trim() !== 'Select an available size to see price') {
          priceEl.textContent = 'Select an available size to see price';
          // Hide compare price if it exists
          const comparePrice = priceEl.parentElement.querySelector('[data-compare-price]');
          if (comparePrice) {
            comparePrice.style.display = 'none';
          }
        }
      });
      
      // Update inventory status
      const inventoryStatusContainer = document.querySelector('[data-product-inventory-status]');
      const inventoryStatusText = document.querySelector('[data-inventory-status-text]');
      if (inventoryStatusContainer && inventoryStatusText) {
        inventoryStatusText.textContent = 'Out of stock';
        inventoryStatusContainer.style.display = '';
        inventoryStatusContainer.setAttribute('data-status', 'out-of-stock');
      }
      
      // Update button to be outlined and disabled
      const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
      addToCartButtons.forEach(btn => {
        btn.classList.add('btn--secondary');
        btn.classList.remove('btn--primary');
        btn.setAttribute('disabled', 'disabled');
        const text = btn.querySelector('[data-add-to-cart-text]');
        if (text) {
          text.textContent = 'Out of stock';
        }
      });
      
      // Hide the release date
      const releaseDateContainer = document.querySelector('[data-product-release-date]');
      if (releaseDateContainer) {
        releaseDateContainer.classList.add('hide');
      }
      
      return;
    }
    
    updateVariantInfo(variant);
    
    // Restore compare price display if it was hidden
    const comparePriceElements = document.querySelectorAll('[data-compare-price]');
    comparePriceElements.forEach(comparePrice => {
      if (comparePrice.style.display === 'none') {
        comparePrice.style.display = '';
      }
    });
    
    // Check if variant is out of stock and update button style
    if (variantInventoryEl) {
      const inventoryMessage = variantInventoryEl.getAttribute('data-inventory-status-message');
      const isOutOfStock = inventoryMessage && inventoryMessage.toLowerCase().includes('out of stock');
      
      const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
      addToCartButtons.forEach(btn => {
        if (isOutOfStock) {
          btn.classList.add('btn--secondary');
          btn.classList.remove('btn--primary');
          btn.setAttribute('disabled', 'disabled');
        } else {
          btn.classList.remove('btn--secondary');
          btn.classList.add('btn--primary');
          btn.removeAttribute('disabled');
        }
      });
    }
  } else {
    console.log("No variant found, showing Out of stock");
    // Show "Out of stock" if we can't find a valid variant
    const inventoryStatusContainer = document.querySelector('[data-product-inventory-status]');
    const inventoryStatusText = document.querySelector('[data-inventory-status-text]');
    
    if (inventoryStatusContainer && inventoryStatusText) {
      inventoryStatusText.textContent = 'Out of stock';
      inventoryStatusContainer.style.display = '';
      inventoryStatusContainer.setAttribute('data-status', 'out-of-stock');
    }
    
    // Update price to show "Select an available size to see price"
    const priceElements = document.querySelectorAll('[data-price]');
    priceElements.forEach(priceEl => {
      // Only update if it's not already showing the message
      if (priceEl.textContent.trim() !== 'Select an available size to see price') {
        priceEl.textContent = 'Select an available size to see price';
        // Hide compare price if it exists
        const comparePrice = priceEl.parentElement.querySelector('[data-compare-price]');
        if (comparePrice) {
          comparePrice.style.display = 'none';
        }
      }
    });
    
    // Update button to be outlined and disabled
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    addToCartButtons.forEach(btn => {
      btn.classList.add('btn--secondary');
      btn.classList.remove('btn--primary');
      btn.setAttribute('disabled', 'disabled');
      const text = btn.querySelector('[data-add-to-cart-text]');
      if (text) {
        text.textContent = 'Out of stock';
      }
    });
    
    // Hide the release date
    const releaseDateContainer = document.querySelector('[data-product-release-date]');
    if (releaseDateContainer) {
      releaseDateContainer.classList.add('hide');
    }
  }
});

// Initialize on page load
function initializeVariantInfo() {
  let variantId = null;
  
  // Try to get from URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const variantParam = urlParams.get('variant');
  if (variantParam) {
    variantId = parseInt(variantParam, 10);
  }
  
  // If not in URL, try form data attribute
  if (!variantId) {
    const formElement = document.querySelector('[data-product-form]');
    if (formElement) {
      const currentProductId = formElement.getAttribute('data-current-product-id');
      if (currentProductId) {
        variantId = parseInt(currentProductId, 10);
      }
    }
  }
  
  // If still not found, try hidden input
  if (!variantId) {
    const idInput = document.querySelector('[name="id"]');
    if (idInput && idInput.value) {
      variantId = parseInt(idInput.value, 10);
    }
  }
  
  // Also try select dropdown
  if (!variantId) {
    const selectInput = document.querySelector('select[name="id"]');
    if (selectInput && selectInput.value) {
      variantId = parseInt(selectInput.value, 10);
    }
  }
  
  if (variantId) {
    const variant = { id: variantId };
    updateVariantInfo(variant);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initializeVariantInfo();
    setTimeout(initializeVariantInfo, 300);
  });
} else {
  initializeVariantInfo();
  setTimeout(initializeVariantInfo, 300);
}

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
